import React from 'react';
import './styles.css';

const Header = () => (
  <header className='home-header'>
    <h2>Inc. This Morning</h2>
    <h1>
      <span>“</span> Blog <span>”</span>
    </h1>
    <p>
      awesome place to make oneself <br /> productive and entertained through
      daily updates.
    </p>
  </header>
);

export default Header;
